import { render, staticRenderFns } from "./StartView.vue?vue&type=template&id=24c7f096&"
import script from "./StartView.vue?vue&type=script&lang=js&"
export * from "./StartView.vue?vue&type=script&lang=js&"
import style0 from "./StartView.vue?vue&type=style&index=0&id=24c7f096&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports